// extracted by mini-css-extract-plugin
module.exports = {"StaffMembersContainer":"Accounts_StaffMembersContainer__2rcJY","StaffMember":"Accounts_StaffMember__1UxjK"};